import {List} from 'immutable';
import getTaggedText from './getTaggedText';

export default function findMatches(text, user) {
  let matches = List([]);
  let lastIndex = -1;
  // TODO remove this count
  let count = 0;
  const substring = getTaggedText(user);
  while ((lastIndex = text.indexOf(substring, lastIndex + 1)) !== -1 && count < 100) {
    count++;
    matches = matches.push({index: lastIndex, user});
  }

  return matches;
}
